module.exports = __webpack_public_path__ + "img/fullrate.e015578a.svg";